<template>
	<div class="sc-wrap-content">
		<div class="sd-divider"></div>
		<div class="sd-content-section">
			<a id="vitalParameters"></a>
			<h3 class="sd-title-right" v-html="translations.scAppVitalTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-content">
					<p v-html="translations.scAppVitalContent1"></p>
					<ul>
						<li v-html="translations.scAppVitalContentB1"></li>
						<li v-html="translations.scAppVitalContentB9"></li>
						<li v-html="translations.scAppVitalContentB2"></li>
						<li v-html="translations.scAppVitalContentB3"></li>
						<li v-html="translations.scAppVitalContentB10"></li>
						<li v-html="translations.scAppVitalContentB4"></li>
						<li v-html="translations.scAppVitalContentB5"></li>
						<li v-html="translations.scAppVitalContentB6"></li>
						<li v-html="translations.scAppVitalContentB7"></li>
						<li v-html="translations.scAppVitalContentB8"></li>
					</ul>
					<p v-html="translations.scAppVitalContent2"></p>
				</div>
				<div class="sd-img sd-img-right">
					<Slideshow :images="computedImages.vitalImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
			</div>
		</div>
		<div class="sd-content-section">
			<a id="questionnaire"></a>
			<h3 class="sd-title-left" v-html="translations.scAppQuestTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-img sd-img-left sd-horizontal">
					<Slideshow :images="computedImages.questImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
				<div class="sd-content">
					<p v-html="translations.scAppQuestContent"></p>
				</div>
				<div class="sd-img sd-img-right sd-vertical">
					<Slideshow :images="computedImages.questImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
			</div>
		</div>
		<div class="sd-content-section">
			<a id="sensor"></a>
			<h3 class="sd-title-right" v-html="translations.scAppSensorTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-content">
					<p v-html="translations.scAppSensorContent1"></p>
					<ul>
						<li v-html="translations.scAppSensorContentB1"></li>
						<li v-html="translations.scAppSensorContentB2"></li>
						<li v-html="translations.scAppSensorContentB3"></li>
					</ul>
					<p>
						<span v-html="translations.scAppSensorContent2"></span>
						<a
							href="https://store.cosinuss.com/products/cosinuss-two?variant=32175832924242"
							target="_blank"
							v-html="translations.scAppSensorContent3"
						></a>
					</p>
					<p v-html="translations.scAppSensorContent4"></p>
					<ul>
						<li v-html="translations.scAppSensorContentB4"></li>
						<li v-html="translations.scAppSensorContentB5"></li>
						<li v-html="translations.scAppSensorContentB6"></li>
						<li v-html="translations.scAppSensorContentB7"></li>
						<li v-html="translations.scAppSensorContentB8"></li>
						<li v-html="translations.scAppSensorContentB9"></li>
					</ul>
					<p>
						<span v-html="translations.scAppSensorContent2"></span>
						<a
							href="https://www.beurer-shop.de/p/beurer-aktivitaetssensor-as-99-pulse-bluetooth/"
							target="_blank"
							v-html="translations.scAppSensorContent3"
						></a>
					</p>
					<p v-html="translations.scAppSensorContent5"></p>
					<ul>
						<li v-html="translations.scAppSensorContentB10"></li>
						<li v-html="translations.scAppSensorContentB11"></li>
						<li v-html="translations.scAppSensorContentB12"></li>
						<li v-html="translations.scAppSensorContentB13"></li>
						<li v-html="translations.scAppSensorContentB14"></li>
						<li v-html="translations.scAppSensorContentB15"></li>
						<li v-html="translations.scAppSensorContentB16"></li>
						<li v-html="translations.scAppSensorContentB17"></li>
						<li v-html="translations.scAppSensorContentB18"></li>
					</ul>
					<p>
						<span v-html="translations.scAppSensorContent2"></span>
						<a href="https://www.garmin.com/de-DE/p/782585/" target="_blank" v-html="translations.scAppSensorContent3"></a>
					</p>
				</div>
				<div class="sd-img sd-img-right">
					<Slideshow :images="computedImages.sensorImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
			</div>
		</div>
		<div class="sd-content-section">
			<a id="event"></a>
			<h3 class="sd-title-left" v-html="translations.scAppEventTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-img sd-img-left sd-horizontal">
					<Slideshow :images="computedImages.eventImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
				<div class="sd-content">
					<p v-html="translations.scAppEventContent"></p>
				</div>
				<div class="sd-img sd-img-right sd-vertical">
					<Slideshow :images="computedImages.eventImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
			</div>
		</div>
		<div class="sd-content-section">
			<a id="appSecurity"></a>
			<h3 class="sd-title-right" v-html="translations.scAppSecurityTitle"></h3>
			<div class="sd-wrap-box">
				<div class="sd-content">
					<ul>
						<li v-html="translations.scAppSecurityContentB1"></li>
						<li v-html="translations.scAppSecurityContentB2"></li>
						<li v-html="translations.scAppSecurityContentB3"></li>
					</ul>
				</div>
				<div class="sd-img sd-img-right">
					<Slideshow :images="computedImages.securityImages" @showFullImage="$emit('showFullImage', $event)" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Slideshow from './Slideshow.vue';
import i18n from '@/translations/i18n';
export default {
	name: 'SmartphoneContent',
	components: {
		Slideshow,
	},
	emits: ['showFullImage'],
	data() {
		return {
			translations: {},
		};
	},
	computed: {
		computedTranslations: function() {
			return {
				scAppVitalTitle: this.$t('scAppVitalTitle'),
				scAppVitalContent1: this.$t('scAppVitalContent1'),
				scAppVitalContentB1: this.$t('scAppVitalContentB1'),
				scAppVitalContentB9: this.$t('scAppVitalContentB11'),
				scAppVitalContentB2: this.$t('scAppVitalContentB2'),
				scAppVitalContentB3: this.$t('scAppVitalContentB3'),
				scAppVitalContentB10: this.$t('scAppVitalContentB12'),
				scAppVitalContentB4: this.$t('scAppVitalContentB4'),
				scAppVitalContentB5: this.$t('scAppVitalContentB5'),
				scAppVitalContentB6: this.$t('scAppVitalContentB6'),
				scAppVitalContentB7: this.$t('scAppVitalContentB7'),
				scAppVitalContentB8: this.$t('scAppVitalContentB8'),
				scAppVitalContent2: this.$t('scAppVitalContent2'),
				scAppQuestTitle: this.$t('scAppQuestTitle'),
				scAppQuestContent: this.$t('scAppQuestContent'),
				scAppSensorTitle: this.$t('scAppSensorTitle'),
				scAppSensorContent1: this.$t('scAppSensorContent1'),
				scAppSensorContentB1: this.$t('scAppSensorContentB1'),
				scAppSensorContentB2: this.$t('scAppSensorContentB2'),
				scAppSensorContentB3: this.$t('scAppSensorContentB3'),
				scAppSensorContent2: this.$t('scAppSensorContent2'),
				scAppSensorContent3: this.$t('scAppSensorContent3'),
				scAppSensorContent4: this.$t('scAppSensorContent4'),
				scAppSensorContentB4: this.$t('scAppSensorContentB4'),
				scAppSensorContentB5: this.$t('scAppSensorContentB5'),
				scAppSensorContentB6: this.$t('scAppSensorContentB6'),
				scAppSensorContentB7: this.$t('scAppSensorContentB7'),
				scAppSensorContentB8: this.$t('scAppSensorContentB8'),
				scAppSensorContentB9: this.$t('scAppSensorContentB9'),
				scAppSensorContent5: this.$t('scAppSensorContent5'),
				scAppSensorContentB10: this.$t('scAppSensorContentB4'),
				scAppSensorContentB11: this.$t('scAppSensorContentB11'),
				scAppSensorContentB12: this.$t('scAppSensorContentB12'),
				scAppSensorContentB13: this.$t('scAppSensorContentB13'),
				scAppSensorContentB14: this.$t('scAppSensorContentB5'),
				scAppSensorContentB15: this.$t('scAppSensorContentB6'),
				scAppSensorContentB16: this.$t('scAppSensorContentB7'),
				scAppSensorContentB17: this.$t('scAppSensorContentB8'),
				scAppSensorContentB18: this.$t('scAppSensorContentB9'),
				scAppSensorContent6: this.$t('scAppSensorContent2'),
				scAppSensorContent7: this.$t('scAppSensorContent3'),
				scAppEventTitle: this.$t('scAppEventTitle'),
				scAppEventContent: this.$t('scAppEventContent'),
				scAppSecurityTitle: this.$t('scAppSecurityTitle'),
				scAppSecurityContentB1: this.$t('scAppSecurityContentB1'),
				scAppSecurityContentB2: this.$t('scAppSecurityContentB2'),
				scAppSecurityContentB3: this.$t('scAppSecurityContentB3'),
			};
		},
		computedImages: function() {
			return {
				vitalImages: [
					{ src: 'AppDashboardScreen.png', alt: this.$t('scAppDashboardScreenAlt') },
					{ src: 'AppMeasurementPlanScreen.png', alt: this.$t('scAppMeasurementPlanScreenAlt') },
					{ src: 'AppMeasurementsScreen.png', alt: this.$t('scAppMeasurementsScreenAlt') },
					{ src: 'AppAboutScreen.png', alt: this.$t('scAppAboutScreenAlt') },
				],
				questImages: [
					{ src: 'AppQuestionnaireScreen1.png', alt: this.$t('scAppQuestionnaireScreenAlt1') },
					{ src: 'AppQuestionnaireScreen2.png', alt: this.$t('scAppQuestionnaireScreenAlt2') },
				],
				sensorImages: [
					{ src: 'AppSensorsScreen1.png', alt: this.$t('scAppSensorsScreenAlt') },
					{ src: 'AppSensorsScreen2.png', alt: this.$t('scAppSensorsScreenAlt') },
					{ src: 'AppArmSensorGarminVivosmart5.png', alt: this.$t('scAppArmSensorGarminVivosmart5rAlt') },
					{ src: 'AppArmSensor.png', alt: this.$t('scAppArmSensorAlt') },
					{ src: 'AppEarSensor.png', alt: this.$t('scAppEarSensorAlt') },
				],
				eventImages: [{ src: 'AppEventScreen.png', alt: this.$t('scAppEventScreenAlt') }],
				securityImages: [
					{ src: 'AppLoginScreen.png', alt: this.$t('scAppLoginScreenAlt') },
					{ src: 'AppCertScreen.png', alt: this.$t('scAppCertScreenAlt') },
					{ src: 'AppQRScreen.png', alt: this.$t('scAppQRScreenAlt') },
				],
			};
		},
	},
	created() {
		this.translations = this.computedTranslations;
		this.hyphenateText();
		window.addEventListener('languageChange', this.languageEvent);
	},
	beforeDestroy() {
		window.removeEventListener('languageChange', this.languageEvent);
	},
	methods: {
		languageEvent() {
			if (i18n.locale !== 'en') this.hyphenateText();
			else this.translations = this.computedTranslations;
		},
		hyphenateText() {
			let that = this;
			this.$global.getHyphenation(this.computedTranslations, function(data) {
				that.translations = data;
			});
		},
	},
};
</script>

<style scoped>
.sc-wrap-content {
	width: 100%;
	margin: auto;
	/* padding: 0px 5%;
	box-sizing: border-box; */
}
</style>
